module.exports = __webpack_public_path__ + "static/media/Zombie Businessman.2abddca1.jpg";